import React, {useContext, useEffect, useRef, useState} from "react";
import {goVehisService} from "../../utils/axios";
import OwlCarousel from "react-owl-carousel";
import ConvertUtils from "../../utils/ConvertUtils";
import {CustomerTypeContext} from "../../context/customer-type-context";
import VehicleOfferListItem from "../../components/VehicleOfferListItem/VehicleOfferListItem";
import OfferSkeletonCard from "../../components/VehicleOfferListItem/OfferSkeletonCard";
import {Link} from "react-router-dom";
import {useMediaQuery} from "react-responsive";
import logoIconWhite from "../../assets/images/icons/logo_icon_white.svg";

function SpecialOffers() {

    const MAX_SPECIAL_OFFERS_COUNT = 12;

    const [specialOffers, setSpecialOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const owlCarouselRef = useRef(null);
    const currentCustomerType = useContext(CustomerTypeContext)[0];
    const isMobile = useMediaQuery({maxWidth: 767});

    useEffect(() => {
        setLoading(true);
        goVehisService.get("vehicles/specialoffers?customerType=" + currentCustomerType)
            .then(response => setSpecialOffers(Array.isArray(response.data) ? response.data.slice(0, MAX_SPECIAL_OFFERS_COUNT) : []))
            .finally(() => setLoading(false));
    }, [currentCustomerType]);

    useEffect(() => {
        if (owlCarouselRef.current != null) {
            owlCarouselRef.current.forceUpdate();
        }
    }, [currentCustomerType]);

    if (!loading && specialOffers.length === 0) {
        return null;
    }

    const offers = specialOffers.map(offer => (
        <VehicleOfferListItem
            isSliderOffer={true}
            showRibbons={true}
            key={offer.id}
            url={"/" + ConvertUtils.stringToUrl(offer.brandName.replace("/", "") + "/" + offer.versionName + "/" + offer.id)}
            offer={offer}
            className="hot-offer"
        />
    ));

    return (
        <section id="hot-offers">
            <div className="container">
                <h2 className="special-offers-heading">Oferty specjalne</h2>
                {loading ? (
                    <div className="special-offers-skeleton-row">
                        {[0, 1, 2, 3].map(i => <OfferSkeletonCard key={i} slider />)}
                    </div>
                ) : (
                    <OwlCarousel
                        ref={owlCarouselRef}
                        id="hot-offers-slider"
                        loop={true}
                        margin={40}
                        nav={true}
                        dots={false}
                        mouseDrag={false}
                        lazyLoad={true}
                        navText={["<", ">"]}
                        responsive={{
                            0: {items: 1, margin: 0},
                            480: {items: 1},
                            768: {items: 2},
                            1024: {items: 3},
                            1199: {items: 4}
                        }}
                    >
                        {offers}
                    </OwlCarousel>
                )}
                <div className="special-offers-cta">
                    <Link
                        to={{pathname: "/lista-ofert", search: "specialOffer=true"}}
                        className="special-offers-btn"
                    >
                        Zobacz wszystkie oferty specjalne
                        <img src={logoIconWhite} alt="" className="search-btn-icon"/>
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default SpecialOffers;
